import igpreview from './igpreview/routes.js';

export default [igpreview];
